import moment from "moment-timezone";
import { useGetMyProfile } from "../profile/use-get-my-profile";

// Fuso padrão quando o perfil ainda não trouxe `utc` (app é BR-cêntrico).
const FALLBACK_TZ = "America/Sao_Paulo";

// `created_at`/`date_sent_coin` são TEXT em UTC no formato
// "YYYY-MM-DD HH:MM:SS.ffffff+00". O backend compara essas strings de forma
// LEXICOGRÁFICA, então os limites precisam casar com esse shape — por isso o
// sufixo ".000000+00" (início) e ".999999+00" (fim).
export const useUserTimezone = () => {
  const { user } = useGetMyProfile();

  // Sempre o fuso do usuário (ex.: vendedor BR -> "America/Sao_Paulo").
  const zone =
    user?.utc && moment.tz.zone(user.utc) ? user.utc : FALLBACK_TZ;

  // hoje (YYYY-MM-DD) no fuso do usuário
  const todayInZone = () => moment.tz(zone).format("YYYY-MM-DD");

  // dia + hora (wall-clock no fuso do user) -> limite UTC comparável ao created_at.
  // edge=false => início do intervalo (.000000+00); edge=true => fim (.999999+00).
  const zonedBoundToUtc = (
    date?: string,
    time = "00:00:00",
    edge = false
  ): string | undefined => {
    if (!date) {
      return undefined;
    }
    const base = moment
      .tz(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss", zone)
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    return `${base}.${edge ? "999999" : "000000"}+00`;
  };

  // timestamp UTC (texto do banco) -> string exibível no fuso do usuário
  const formatInZone = (value?: string | null, withHour = true): string => {
    if (!value) {
      return "";
    }
    const parsed = moment(String(value).replace(" ", "T"));
    if (!parsed.isValid()) {
      return value;
    }
    return parsed
      .tz(zone)
      .format(withHour ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY");
  };

  return { zone, todayInZone, zonedBoundToUtc, formatInZone };
};
